import clsx from "clsx";
import style from "./net-income.module.scss";
import { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { formateNumber } from "@/lib/utils/currency";
import { Skeleton } from "@mantine/core";
import StatusMsg from "@/components/common/status-msg";
import { SiteLoader } from "@/lib/utils/theme";
import { SecBoxLoader } from "@/components/layout/sec-box";
import { useSelector } from "react-redux";

const NetIncome = ({ className, dashboardTxt }) => {
	const [error, setError] = useState({ message: "", variant: "" });
	const [netIncome, setNetIncome] = useState();
	const [loading, setLoading] = useState(true);
	const { remoteId } = useSelector((state) => state.session);

	useEffect(() => {
		const getNetIncome = async () => {
			setLoading(true);
			const params = {
				action: "netIncome",
				token: process.env.NEXT_PUBLIC_TOKEN,
				casino: process.env.NEXT_PUBLIC_CASINO,
				remote_id: remoteId,
			};
			try {
				const response = await axios.get(
					`${process.env.NEXT_PUBLIC_ADMIN_API_DOMAIN}/casinos/casino-admin-reports`,
					{ params },
				);
				if (response?.data?.status === 200) {
					setNetIncome(response?.data?.commissionInfo || 0);
				} else {
					setError({ message: response?.message, variant: "danger" });
				}
			} catch (error) {
				setError({ message: error?.message, variant: "danger" });
			} finally {
				setLoading(false);
			}
		};

		getNetIncome();
	}, [remoteId]);

	return (
        <div className={clsx(className, style.net_income)}>
            {loading ? (
                <SecBoxLoader />
            ) : error?.message ? (
                <div className="full_screen_msg">
                    <StatusMsg title={error?.message} variant={error?.variant} />
                </div>
            ) : (
                <div className={style.content}>
                    <h3 className={clsx(style.title, 'sec_box_title')}>{dashboardTxt?.net_income}</h3>
                    <div className={style.item}>
                        {dashboardTxt?.current_month}: <span className={style.amount}>{formateNumber(Number(netIncome?.currentGGR?.totalCommission.toFixed(4)))}</span>
                    </div>
                    <div className={style.item}>
                        {dashboardTxt?.previous_month}: <span className={style.amount}>{formateNumber(Number(netIncome?.lastGGR?.totalCommission.toFixed(4)))}</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NetIncome;
